import React from "react";

interface Props {
    mt: string | undefined
    mb: string | undefined
    text: string,
    color: string | undefined
    textAlign: any | undefined
    onClick: () => void | undefined
    actionIcon: boolean
    isOneLine: boolean
}

const Small = ({ actionIcon, textAlign, mt, mb, text, color, onClick, isOneLine }: Props) => {
    return (
        <span onClick={onClick} style={{ color: color, marginTop: mt, marginBottom: mb, textAlign: textAlign }} className={"custom-Small " + (actionIcon ? "actionIcon " : '') + (isOneLine ? 'custom-Small-oneline' : '')}>{text}</span>
    )
}

Small.defaultProps = {
    mt: undefined,
    mb: undefined,
    color: undefined,
    textAlign: 'center',
    onClick: undefined,
    actionIcon: false,
    isOneLine: false
}

export default Small;